import { EyeOutlined } from "@ant-design/icons";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Tooltip,
  Typography,
} from "antd";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import RecordStatus from "../../../components/RecordStatus";
import appStatic from "../../../config/appStatic";
import { rightAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../customer.config";
import CustomerInfo from "./DetailedCustomer/CustomerInfo";
import OTPBalanceModal from "./DetailedCustomer/OTPBalanceModal";
import AccountsOverview from "./DetailedCustomer/tabs/AccountsOverview";
import Address from "./DetailedCustomer/tabs/address/Address";
import ApplyCharges from "./DetailedCustomer/tabs/charges/ApplyCharges";
import CounterPartyInfo from "./DetailedCustomer/tabs/counterParty/CounterPartyInfo";
import Document from "./DetailedCustomer/tabs/Document";
import GeneralTab from "./DetailedCustomer/tabs/General";
import KYCInfoTab from "./DetailedCustomer/tabs/kycInfo/KYCInfo";
import ManageLimit from "./DetailedCustomer/tabs/limitAndLiability/ManageLimit";
import Mandates from "./DetailedCustomer/tabs/Manadates";
import RelationshipInfo from "./DetailedCustomer/tabs/relationship/RelationshipInfo";
import ManageStandingInstructions from "./DetailedCustomer/tabs/standingInstructions/ManageStandingInstructions";
import dayjs from "dayjs";
import { Log } from "victory";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import ChannelServices from "./DetailedCustomer/tabs/channelServices/ChannelServices";
const { Text, Title } = Typography;

const DetailCST0100 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { monthList } = appStatic;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [customerDetails, setCustomerDetails] = useState({});
  const [currentCustomerDetails, setCurrentCustomerDetails] = useState({});
  const [activeCasaList, setActiveCasaList] = useState([]);
  const [closedCasaList, setClosedCasaList] = useState([]);
  const [loansList, setLoansList] = useState([]);
  const [closedLoanList, setClosedLoanList] = useState([]);
  const [addressDetails, setAddressDetails] = useState([]);
  const [relationshipDetails, setRelationshipDetails] = useState([]);
  const [savingsList, setSavingsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [retrievedBalances, setRetrievedBalances] = useState({});

  const dispatch = useDispatch();
  const [activeTabKey, setActiveTabKey] = useState("general");
  const [displayCustomerInfo, setDisplayCustomerInfo] = useState("");
  const otpModalRef = useRef();
  const childref = useRef();

  const tabList = [
    {
      key: "general",
      label: "General",
      disabled: !BOM.HasPermission("READ_CLIENT"),
    },
    {
      key: "accountsOverview",
      label: "Accounts Overview",
      disabled: !BOM.HasPermission("READ_CLIENT"),
    },
    {
      key: "kycInfo",
      label: "KYC Info",
      disabled: !BOM.HasPermission("READ_CLIENT"),
    },
    {
      key: "address",
      label: "Address",
      disabled: !BOM.HasPermission("READ_ADDRESS"),
    },
    {
      key: "limitsAndLiabilities",
      label: "OD Limits & Liabilities",
      disabled: !BOM.HasPermission("READ_CLIENT_LIMIT"),
    },
    {
      key: "mandates",
      label: "Mandates",
      disabled: !BOM.HasPermission("READ_MANDATE"),
    },
    {
      key: "document",
      label: "Document",
      disabled: !BOM.HasPermission("READ_DOCUMENT"),
    },
    {
      key: "relationship",
      label: "Relationship",
      disabled: !BOM.HasPermission("READ_FAMILYMEMBERS"),
    },
    // {
    //   "key": "collateral",
    //   "label": "Collateral"
    // },
    // {
    //   "key": "applyCharge",
    //   "label": "Apply Charge"
    // },
    {
      key: "standingInstructions",
      label: "Standing Instructions",
      disabled: !BOM.HasPermission("READ_STANDINGINSTRUCTION"),
    },
    {
      key: "chargesAndInterest",
      label: "Charges & Interest",
      disabled: !BOM.HasPermission("READ_CLIENTCHARGE"),
    },
    {
      key: "counterParty",
      label: "Counterparty",
      disabled: !BOM.HasPermission("READ_CLIENTCHARGE"),
    },
    {
      key: "channelServices",
      label: "Channel Services",
      disabled:
        // !BOM.HasPermission("READ_CLIENTCHARGE") ||
        // customerDetails?.clientType?.name?.toLowerCase() !== "corporate" ||
        customerDetails?.legalForm?.value?.toLowerCase() !== "entity",
    },
  ];
  useEffect(() => {
    console.log(state);

    getDetailById();
    getAccountOverviewList();
    BOM.HasPermission("READ_ADDRESS") && getAddresses();
    BOM.HasPermission("READ_FAMILYMEMBERS") && getRelationshipDetail();
  }, []);
  console.log(customerDetails);

  const handleViewBalance = (accountId, accountData) => {
    otpModalRef.current?.showModal(accountId, accountData);
  };

  const handleBalanceRetrieved = (accountId, balanceData) => {
    setRetrievedBalances((prev) => ({
      ...prev,
      [accountId]: balanceData,
    }));
  };

  useEffect(() => {
    if (Object.keys(retrievedBalances).length > 0) {
      getAccountOverviewList();
    }
  }, [retrievedBalances]);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${state?.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCurrentCustomer = {
          key: objDetail?.id,
          id: objDetail?.id,
          name: objDetail?.displayName ? objDetail?.displayName : "-",
          clientno: objDetail?.accountNo ? objDetail?.accountNo : "-",
          externalId: objDetail?.externalId ? objDetail?.externalId : "-",
          status: objDetail?.status ? objDetail?.status.value : "-",
          branch: objDetail?.officeName ? objDetail?.officeName : "-",
          staff: objDetail?.staffName ? objDetail?.staffName : "-",
          branchId: objDetail?.officeId ? objDetail?.officeId : "-",
        };
        setIsLoading(false);
        setCustomerDetails(objDetail);
        setCurrentCustomerDetails(tempCurrentCustomer);

        useForm.setFieldsValue({
          tier: objDetail?.tier,
          fullname: objDetail?.fullname,
          previousName: objDetail?.previousName,
          issuingAuthority: objDetail?.issuingAuthority,
          idTypeId: objDetail?.idType?.id,
          idNo: objDetail?.idNo,
          expiryDate: dayjs(BOM.FormatArrayDate(objDetail?.expiryDate)),

          directorCustomer: objDetail?.directorCustomer,
          establishedRelationship: objDetail?.establishedRelationship,

          centralBankIndustryCode: objDetail?.centralBankIndustryCode,
          economicActivityCode: objDetail?.economicActivityCode,
          annualTurnover: objDetail?.annualTurnover,
          isRetail: objDetail?.retail,
          isSme: objDetail?.sme,
          isInterCompany: objDetail?.interCompany,
          termRating: objDetail?.termRating,
          creditRating: objDetail?.creditRating?.id,
          centralGovernmentRated: objDetail?.centralGovernmentRated,
          nationalCode: objDetail?.nationalCode,
          hasClientMoney: objDetail?.hasClientMoney,
          internalClientReconFrequency: objDetail?.internalClientReconFrequency,
          externalClientReconFrequency: objDetail?.externalClientReconFrequency,
          treasuryDealerLines: objDetail?.treasuryDealerLines,

          emailAddress: objDetail?.emailAddress,
          daytimePhoneNo: objDetail?.daytimePhoneNo,
          eveningPhoneNo: objDetail?.eveningPhoneNo,

          taxId: objDetail?.taxId,
          nonPerforming: objDetail?.nonPerforming,

          countryOfRisk: objDetail?.countryOfRisk?.id,

          politicallyExposed: objDetail?.politicallyExposed,
          deceased: objDetail?.deceased,
          dgsEligible: objDetail?.dgsEligible,
          dgsEligibleReason: objDetail?.dgsEligibleReason,
        });

        /**
         * clear all active right button by default
         */
        rightAction(cnt.CLEAR_RIGHT_BTN);

        /**
         * Enable activate or close butto
         * base on status
         */

        switch (objDetail?.status.value?.toLowerCase()) {
          case "active":
            BOM.HasPermission("CLOSE_CLIENT") && rightAction(cnt.RIGHT_REJECT_BTN);
            break;
          case "submitted and pending approval":
            // BOM.HasPermission("CLOSE_CLIENT") &&
            rightAction(cnt.RIGHT_APPROVE_BTN);
            break;
        }

        // render customer info
        setDisplayCustomerInfo(
          <CustomerInfo
            backOnClick={backOnClick}
            session={session}
            currentCustomerObj={objDetail}
          />,
        );

        setIsLoading(false);
      }
    });
  };

  const getAccountOverviewList = () => {
    const url = `${apiConfig.Clients}/${state.id}/accounts`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempLoansArray = [];
        let tempSavingsArray = [];

        objList?.savingsAccounts
          ?.filter((item) => item?.status?.active === true)
          ?.forEach((element) => {
            const hasRetrievedBalance = retrievedBalances[element?.id];
            tempSavingsArray.push({
              ...element,
              key: element?.id,
              id: element?.id,
              accountNo: element?.accountNo ? element?.accountNo : "-",
              productName: element?.productName ? element?.productName : "-",
              casaAccount: element?.productName ? element?.productName : "-",
              actualBalance: element?.accountBalance || element?.availableBalance || 0,
              balanceCurrency: element?.currency?.code || "NGN",
              balanceDisplaySymbol:
                element?.currency?.displaySymbol || element?.currency?.code || "NGN",
              availableBalance: hasRetrievedBalance ? (
                <Text strong style={{ color: "#BA24D5", fontSize: "14px" }}>
                  {(() => {
                    try {
                      const formatted = new Intl.NumberFormat("en-NG", {
                        style: "currency",
                        currency: hasRetrievedBalance.currency,
                        minimumFractionDigits: 2,
                      }).format(hasRetrievedBalance.availableBalance);

                      // Replace with custom display symbol if different
                      if (
                        hasRetrievedBalance.displaySymbol &&
                        hasRetrievedBalance.displaySymbol !== hasRetrievedBalance.currency
                      ) {
                        return formatted.replace(/^[^\d\s-]+/g, hasRetrievedBalance.displaySymbol);
                      }
                      return formatted;
                    } catch (error) {
                      // Fallback formatting
                      return `${
                        hasRetrievedBalance.displaySymbol || hasRetrievedBalance.currency
                      } ${hasRetrievedBalance.availableBalance.toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}`;
                    }
                  })()}
                </Text>
              ) : (
                <Tooltip title="View Available Balance">
                  <Button
                    type="primary"
                    className="of-primaryBtnColor"
                    icon={<EyeOutlined />}
                    onClick={() => handleViewBalance(element?.id, element)}
                    shape="round"
                    size="small"
                  />
                </Tooltip>
              ),
              lastActive: element?.lastActiveTransactionDate
                ? `${element?.lastActiveTransactionDate[2]} ${
                    monthList[element?.lastActiveTransactionDate[1] - 1]
                  } ${element?.lastActiveTransactionDate[0]}`
                : "-",
              maturityDate: element?.maturityDate
                ? BOM.DateTime(element?.maturityDate, "only-date")
                : "-",
              status:
                element?.status.active === true
                  ? "Active"
                  : element?.status.active === false
                    ? "Closed"
                    : "-",
            });
          });
        setSavingsList(tempSavingsArray);

        objList?.loanAccounts.forEach((element) => {
          tempLoansArray.push({
            ...element,
            key: element?.id,
            id: element?.id,
            accountNo: element?.accountNo ? element?.accountNo : "-",
            loanAccount: element?.productName ? element?.productName : "-",
            productName: element?.productName ? element?.productName : "-",
            originalLoan: element?.originalLoan ? element?.originalLoan : "-",
            amountPaid: element?.amountPaid ? element?.amountPaid : "-",
            loanType: element?.loanType ? element?.loanType.value : "-",
            loanBalance: element?.loanBalance ? element?.loanBalance : "-",
          });
        });
        setLoansList(tempLoansArray);
      }
    });
  };

  const getAddresses = () => {
    setIsLoading(true);

    const url = `${apiConfig.Client}/${state.id}/addresses`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setIsLoading(false);
        // console.log(objDetail);
        setAddressDetails(objDetail);

        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });
        setIsLoading(false);
      }
    });
  };

  const getRelationshipDetail = () => {
    const url = `${apiConfig.Clients}/${state.id}/familymembers`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        setRelationshipDetails(objList);
      }
    });
  };

  const onTabChange = (key) => {
    // console.log(key);
    setActiveTabKey(key);
  };

  function backOnClick() {
    navigate("/cst0100", { replace: true });
  }

  const contentListNoTitle = {
    general: <GeneralTab customerDetails={customerDetails} />,
    accountsOverview: (
      <AccountsOverview
        activeCasaList={activeCasaList}
        closedCasaList={closedCasaList}
        loansList={loansList}
        closedLoanList={closedLoanList}
        savingsList={savingsList}
        // currentCustomerObj={state}
      />
    ),
    kycInfo: (
      <KYCInfoTab
        currentCustomerObj={state}
        customerDetails={customerDetails}
        refreshList={getDetailById}
        useForm={useForm}
      />
    ),
    address: (
      <Address
        currentCustomerObj={state}
        customerDetails={customerDetails}
        addressDetails={addressDetails}
        refreshList={getAddresses}
        userData={userData}
      />
    ),
    standingInstructions: <ManageStandingInstructions currentCustomerObj={state} />,
    limitsAndLiabilities: <ManageLimit currentCustomerObj={state} />,
    mandates: <Mandates />,
    document: <Document currentCustomerObj={state} />,
    relationship: (
      <RelationshipInfo
        currentCustomerObj={state}
        relationshipDetails={relationshipDetails}
        session={session}
      />
    ),
    chargesAndInterest: (
      <ApplyCharges currentCustomerObj={currentCustomerDetails} userData={userData} />
    ),
    counterParty: (
      <CounterPartyInfo
        currentCustomerObj={currentCustomerDetails}
        customerDetails={customerDetails}
        userData={userData}
      />
    ),
    channelServices: (
      <ChannelServices
        currentCustomerObj={currentCustomerDetails}
        customerDetails={customerDetails}
        userData={userData}
      />
    ),
  };

  function handleOnActivateClose() {
    console.log();
    childref?.current?.showModal();
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={() => handleOnActivateClose()}
      onReject={() => handleOnActivateClose()}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailCustomer}
        pageItems={staticConfig.detailBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* customer info here */}
        {displayCustomerInfo}
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>

        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>

      {/* MODALS CALL */}
      <UpdateProfileBlockModal
        ref={childref}
        userData={userData}
        currentCustomerObj={state}
        refreshList={getDetailById}
      />

      {/* <OTPBalanceModal
        ref={otpModalRef}
        userData={userData}
        currentCustomerDetails={currentCustomerDetails}
      /> */}
      <OTPBalanceModal
        ref={otpModalRef}
        userData={userData}
        currentCustomerDetails={currentCustomerDetails}
        onBalanceRetrieved={handleBalanceRetrieved}
      />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(DetailCST0100);

// DEFINED MODALs
// update customer profile status ACTIVATE/RE-ACTIVATE
const UpdateProfileBlockModal = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const { currentCustomerObj, userData, refreshList } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const [closureOptions, setClosureOptions] = useState([]);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getTemplate();
  }, []);

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function getTemplate() {
    const params = { commandParam: "close" };
    const url = `${apiConfig.Clients}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempClosureOptions = [];

        objList?.narrations?.forEach((element) => {
          tempClosureOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setClosureOptions(tempClosureOptions);
        setIsLoading(false);
      }
    });
  }

  const renderLabel = (key) => {
    switch (key?.toLowerCase()) {
      case "active":
        return `Close Customer Profile: ${currentCustomerObj?.clientno}`;
      case "closed":
        return `Activate Customer Profile: ${currentCustomerObj?.clientno}`;
    }
  };

  const renderReasonField = (key) => {
    switch (key?.toLowerCase()) {
      // Display reason field if the current status is active or approve
      case "active":
      case "approved":
        return (
          <>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.closureReason}
                name="closureReasonId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.closureReason),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.closureReason} *`, "select")}
                  options={closureOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
          </>
        );
      default:
        break;
    }
  };
  const onSubmit = (formValues) => {
    const url = `${apiConfig.Clients}/${currentCustomerObj.id}`;
    const params = {};

    switch (currentCustomerObj?.status?.toLowerCase()) {
      case "active":
        params.command = "close";
        formValues.closureDate = BOM.DateTime(formValues.generalDate, "only-date");
        delete formValues.generalDate;
        break;
      case "pending":
        params.command = "activate";
        formValues.activationDate = BOM.DateTime(formValues.generalDate, "only-date");
        delete formValues.generalDate;
        break;
    }

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.customerStatusMsg);
          navigate("/cst0100");

          // setIsModalOpen(false);
          // refreshList();
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/cst0100");
          setIsLoading(false);
        },
      },
    );
  };
  return (
    <>
      <Modal
        title="Update Customer Profile Status"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              unAuthorisedLimit: 0,
              utilizedLimit: 0,
              unUsedLimit: 0,
              digitsAfterDecimal: 2,
              inMultiplesOf: 100,
            }}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} size="large" tip="Saving...">
          <Row>
            <Divider orientation="left">{renderLabel(currentCustomerObj?.status)}</Divider>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.date}
                name="generalDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.date),
                  },
                ]}
              >
                <DatePicker
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.date)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            {/* date field */}
            {renderReasonField(currentCustomerObj?.status)}
          </Row>
        </Spin>
      </Modal>
    </>
  );
});
